import React, { useState, useEffect } from "react";
import axios from "axios";
import host from "../host";
import "./COR.css";
import Spinner from "../Spinner";

function COR(props) {
  const student = props.student;
  const trimesters = props.trimesters;
  const [cor, setCor] = useState([]);
  const [loadingCOR, setLoadingCor] = useState(true);
  const [selectedTrim, setSelectedTrim] = useState(0);

  // Initial fetch runs once; subsequent loads follow selected trimester changes.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    loadCor();
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    loadCor();
  }, [selectedTrim]);

  const loadCor = () => {
    setLoadingCor(true);
    axios
      .post(`${host}getCOR`, {
        studentId: student.idstudent,
        idsyc: selectedTrim,
      })
      .then((res) => {
        setCor(res.data);
        setLoadingCor(false);
      });
  };

  const totalUnits = () => {
    let total = 0;
    for (let i = 0; i < cor.length; i++) {
      total = total + parseFloat(cor[i].units);
    }
    return total;
  };

  const renderCor = () => {
    if (cor.length === 0) {
      return (
        <p className="cor-empty" role="status">
          You are not enrolled in the selected trimester.
        </p>
      );
    } else {
      return (
        <React.Fragment>
          <div className="totalUnits">Total Units: {totalUnits()}</div>

          {cor.map((val, key) => {
            return (
              <div className="cor" key={key}>
                <div className="courseCode">
                  {val.subject_name}/{val.class_name}
                </div>
                <div className="description">{val.subject_description}</div>
                <div className="units">Units: {val.units}</div>
                <div className="room">Room: {val.roomname}</div>
                <div className="sched">Schedule: {val.schedule}</div>
                <div className="instructor">Instructor: {val.instructor}</div>
              </div>
            );
          })}
        </React.Fragment>
      );
    }
  };
  return (
    <React.Fragment>
      <div className="corTitle">
        <h1>Certificate of Registration</h1>
      </div>

      <div className="corContainer">
        {!loadingCOR && (
          <div className="selectTrimester">
            <select
              className="peaci-select w-full max-w-md"
              value={selectedTrim}
              onChange={(e) => {
                setSelectedTrim(e.target.value);
              }}
            >
              <option value="0" hidden disabled>
                Select Trimester
              </option>
              {trimesters.map((val, key) => {
                return (
                  <option value={val.idsyc} key={key}>
                    {val.sy_name}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {loadingCOR ? <Spinner /> : renderCor()}
      </div>
    </React.Fragment>
  );
}

export default COR;
